import React from 'react';
import PropTypes from 'prop-types';
import ImageLoader from 'react-loading-image';
import _ from 'lodash';

import { Spinner } from '@breezeway/brzw-components';
import { image } from '../../../../utils';

import './cloudinary_image.scss';

const CLASS_NAME = 'cloudinary-image-v2';

const CloudinaryImage = ({ bucket, errorElement, photoKey, options, className, withLoader }) => {
  const renderLoading = () => (
    <div className={`${CLASS_NAME}__loader-wrapper`}>
      <Spinner />
    </div>
  );

  const renderError = () => {
    const shouldUseCustomErrorElement = !_.isEmpty(errorElement);
    const error = shouldUseCustomErrorElement ? errorElement : 'Error';

    return <div className={`${CLASS_NAME}__error`}>{error}</div>;
  };

  if (_.isEmpty(photoKey) || _.isEmpty(bucket)) {
    return renderError();
  }

  const publicId = bucket ? `${bucket}/${photoKey}` : photoKey;
  const imageUrl = image.getCloudinaryUrl(publicId, options);

  return withLoader ? (
    <ImageLoader src={imageUrl} className={className} loading={renderLoading} error={renderError} />
  ) : (
    <img src={imageUrl} className={className} alt="" />
  );
};

CloudinaryImage.propTypes = {
  bucket: PropTypes.string,
  className: PropTypes.string,
  errorElement: PropTypes.node,
  options: PropTypes.shape({}),
  photoKey: PropTypes.string,
  withLoader: PropTypes.bool,
};

CloudinaryImage.defaultProps = {
  withLoader: false,
};

export default CloudinaryImage;
